import { Alert, Button, Container, Stack, Text, Title } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

export function AppErrorFallback() {
  const { t } = useTranslation();
  return (
    <Container size="sm">
      <Stack gap={16}>
        <Title size="lg">{t("marketplace.loadErrorTitle")}</Title>
        <Text tone="subtle">{t("marketplace.appErrorDescription")}</Text>
        <Alert tone="negative" title={t("common.refreshAndTryAgain")} />
        <Button onClick={() => window.location.reload()} variant="outline">
          {t("common.refresh")}
        </Button>
      </Stack>
    </Container>
  );
}
